import api from './api';

export interface YomanInviteRequest {
  patient_id: number;
  meeting_type_id?: number;
  therapist_id?: number;
}

export interface YomanInviteResponse {
  invite_url: string;
}

export const yomanService = {
  async createInvite(request: YomanInviteRequest): Promise<YomanInviteResponse> {
    const response = await api.post('/yoman/invite', request);
    return response.data;
  },
};
